import { GeeksWithdrawal } from '@/models/admin-panel';

export function isWithdrawalsCollapseVisible(withdrawal: GeeksWithdrawal): boolean {
  return withdrawal.transactions.length > 1;
}

export function initializeNotCollapsedList<T>(data: T[]) {
  data.forEach((e: T, index: number) => {
    data[index] = { ...e, collapsed: false };
  });
}

export function initializeCollapsedList<T>(data: T[]) {
  data.forEach((e: T, index: number) => {
    data[index] = { ...e, collapsed: true };
  });
}
